<template>
  <div class="menu" :class="{ 'is-open': isOpen }">
    <div class="menu-overlay" @click.self="close">
      <div class="menu-content-wrapper">
        <div class="menu-content" ref="scrollArea">
          <header class="menu-header">
            <div v-if="!isFacility" class="menu-header-enforcement-date-time">
              <p class="text-break">{{enforcementStartDateTime}}</p>
            </div>
            <div class="menu-header-title">
              <p class="text-break">{{ name }} さま</p>
            </div>
            <div class="menu-header-subtitle">
              <p class="text-break">{{ email }}</p>
            </div>
            <div v-if="usageLimitFlag == 1 && !isFacility" class="menu-header-usage-limit-days">
              <p class="text-break">利用制限まであと{{ usageLimitDays }}日</p>
            </div>
          </header>
          <ul class="menu-link-list">
            <li
              :class="'menu-link-item menu-' + menu.url.function_code"
              v-for="menu in menus"
              :key="menu.url.path"
              @click="close"
            >
              <MenuLink
                :url="menu.url.path"
                :external="menu.url.external"
              >
                <span class="menu-link-icon">
                  <i :class="[menu.icon]"></i>
                </span>
                <span class="menu-link-text" v-html="menu.name" />
              </MenuLink>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import MenuLink from './MenuLink'

export default {
  components: {
    MenuLink
  },
  computed: {
    isOpen() {
      return this.$store.state.navbar.isGlobalMenuOpen
    },
    menus() {
      return this.$store.getters['app/menus']
    },
    name() {
      return this.$store.getters['auth/name']
    },
    email() {
      return this.$store.getters['auth/email']
    },
    enforcementStartDateTime() {
      return this.$store.getters['app/getEnforcementStartDateTime']
    },
    usageLimitFlag() {
      return this.$store.getters['app/getUsageLimitFlag']
    },
    usageLimitDays() {
      return this.$store.getters['app/getUsageLimitDays']
    },
    isFacility() {
      return this.$store.getters['auth/isFacility']
    }
  },
  methods: {
    close() {
      this.$store.commit('navbar/toggleGlobalMenu')
    }
  },
  watch: {
    isOpen(val) {
      if (val) {
        this.$nextTick(() => {
          this.$refs.scrollArea.scrollTop = 0
        })
      }
    }
  }
}
</script>
